import { CompanyDetailsInterface, ICompanyImpressum } from '../exports/Interfaces';

export interface OwnImpressum {
  company_id: number;
  company_name: string;
  content: string;
}

/**
 * Which imprint a restaurant publishes. A self-serve partner's restaurant pastes its own in
 * the dashboard (`impressum_content`); nothing is generated from its business profile, and
 * no text means no imprint at all. Every other restaurant keeps the resolved Impressum.
 */
export default class ImpressumResource {
  public static usesOwnImpressum(company: CompanyDetailsInterface | null | undefined): boolean {
    return !!company?.service_provider?.uses_own_impressum;
  }

  public static hasOwnImpressum(company: CompanyDetailsInterface | null | undefined): boolean {
    return ImpressumResource.usesOwnImpressum(company) && !!company?.impressum_content?.trim();
  }

  /**
   * Every franchise restaurant's pasted imprint, from the franchise list once it has loaded.
   * The current restaurant's own text stands in while the list is still loading, when it
   * could not be loaded, and when it holds no imprint at all (an empty franchise, or one
   * whose entries predate the field), so the page is never blank for a restaurant whose
   * footer links it.
   */
  public static ownImpressums(
    company: CompanyDetailsInterface | null | undefined,
    franchiseImpressums: ICompanyImpressum[] | undefined,
  ): OwnImpressum[] {
    const fromFranchise = (franchiseImpressums ?? [])
      .map((item) => ({
        company_id: item.company_id,
        company_name: item.company_name,
        content: item.content ?? '',
      }))
      .filter((item) => item.content.trim() !== '');

    if (fromFranchise.length > 0) {
      return fromFranchise;
    }

    const own = {
      company_id: company?.id ?? 0,
      company_name: company?.name ?? '',
      content: company?.impressum_content ?? '',
    };

    return own.content.trim() !== '' ? [own] : [];
  }
}
